/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { RecipesAutoTreatContext } from '../contexts/RecipesAutoTreatContext';
import { MachinesContext } from '../../../modules/machinesAdminManagement/contexts/MachinesContext';
import RecipesAutoTreatDetail from './RecipesAutoTreatDetailPage';
import RecipesAutoTreatList from './RecipesAutoTreatList';
import MachineStatusBanner from '../../../modules/shared/machineManagement/MachineStatusBanner';

const RecipesAutoTreatPage: React.FunctionComponent = () => {
  const [initialDataLoaded, setDataLoaded] = React.useState(false);

  const { detailPage, activeMachine } = React.useContext(RecipesAutoTreatContext);
  const { fetchAutoTreatMachines } = React.useContext(MachinesContext);

  React.useEffect(() => {
    const getMachines = async () => {
      if (!initialDataLoaded) {
        setDataLoaded(true);
        fetchAutoTreatMachines();
      }
    };

    getMachines();
  }, [initialDataLoaded, setDataLoaded]);

  const autoTreatRecipePage = () => {
    if (detailPage) {
      return 'updatePage';
    }

    return 'listPage';
  };

  return (
    <>
      <MachineStatusBanner activeMachine={activeMachine} />
      {
        {
          updatePage: <RecipesAutoTreatDetail />,
          listPage: <RecipesAutoTreatList />,
        }[autoTreatRecipePage()]
      }
    </>
  );
};

export default RecipesAutoTreatPage;
